/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AwsSourceAccountAttributesInput } from '../models/AwsSourceAccountAttributesInput';
import { AzureSourceAccountAttributesInput } from '../models/AzureSourceAccountAttributesInput';
import { GcpSourceAccountAttributesInput } from '../models/GcpSourceAccountAttributesInput';
import { MongoAtlasSourceAccountAttributesInput } from '../models/MongoAtlasSourceAccountAttributesInput';
import { Provider } from '../models/Provider';

export class SourceAccountAttributesInput {
  'cloudProvider': Provider;
  'aws'?: AwsSourceAccountAttributesInput | null;
  'azure'?: AzureSourceAccountAttributesInput | null;
  'gcp'?: GcpSourceAccountAttributesInput | null;
  'mongoAtlas'?: MongoAtlasSourceAccountAttributesInput | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "cloudProvider",
      "baseName": "cloudProvider",
      "type": "Provider",
      "format": ""
    },
    {
      "name": "aws",
      "baseName": "aws",
      "type": "AwsSourceAccountAttributesInput",
      "format": ""
    },
    {
      "name": "azure",
      "baseName": "azure",
      "type": "AzureSourceAccountAttributesInput",
      "format": ""
    },
    {
      "name": "gcp",
      "baseName": "gcp",
      "type": "GcpSourceAccountAttributesInput",
      "format": ""
    },
    {
      "name": "mongoAtlas",
      "baseName": "mongoAtlas",
      "type": "MongoAtlasSourceAccountAttributesInput",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SourceAccountAttributesInput.attributeTypeMap;
  }

  public constructor() {
  }
}



